import { useEffect, useRef } from "react";
import { ListChildComponentProps } from "react-window";
import { TranscriptionDisplayRow } from "../Stores/AcxTranscriptionStore";
import { PlayerOptions } from "components/SoundClipEditor/SoundClipEditor";
import { SpeakerStore } from "../Stores/SpeakerStore/SpeakerStore";
import SegmentHeader from "./SegmentHeader";
import BlurbBox from "./BlurbBox/BlurbBox";
import { Box, Divider } from "@mui/material";

export type TranscriptionRowData = {
    rows: TranscriptionDisplayRow[];
    setSize: (index: number, size: number) => void;
    windowWidth: number;
    hasEvaluation: boolean;
    audioClip?: { status: "default" | "success" | "error" | "loading" };
    onClip?: (start: number, end: number) => void;
    playerBlurb?: (playerOptions: PlayerOptions) => void;
    speakerStore?: SpeakerStore;
    disableClip?: boolean;
};

function TranscriptionRow({
    data,
    index,
    style,
}: ListChildComponentProps<TranscriptionRowData>) {
    const {
        rows,
        setSize,
        windowWidth,
        hasEvaluation,
        audioClip,
        onClip,
        playerBlurb,
        speakerStore,
        disableClip,
    } = data;
    const row = rows[index];
    const rowRef = useRef<HTMLDivElement>(null);

    // Measure this rendered row so the virtual list can use its real height.
    useEffect(() => {
        setSize(index, rowRef.current?.getBoundingClientRect().height ?? 0);
    }, [setSize, index, windowWidth, row]);

    const renderRow = () => {
        if (row.type === "divider") {
            return (
                <Box sx={{ py: 1 }}>
                    <Divider />
                </Box>
            );
        }
        if (row.type === "segmentHeader") {
            return <SegmentHeader section={row.section} />;
        }
        return (
            <BlurbBox
                blurb={row.blurb}
                hasEvaluation={hasEvaluation}
                toolTipOpen={false}
                audioClip={audioClip}
                onCreateClip={async (timeArray) => {
                    onClip?.(timeArray[0], timeArray[1]);
                }}
                playerBlurb={playerBlurb}
                index={index}
                speakerStore={speakerStore}
                disableClip={disableClip}
            />
        );
    };

    return (
        <div style={{ ...style, whiteSpace: "normal" }}>
            <div ref={rowRef}>{renderRow()}</div>
        </div>
    );
}

export default TranscriptionRow;
